import { Autoplay, Navigation, Pagination, Swiper } from "swiper";

Swiper.use([Autoplay, Navigation, Pagination]);

export const carrousel = function (el) {
    const swiper = new Swiper(el, {
        speed: 500,
        centeredSlides: true,
        spaceBetween: 40,
        slidesPerView: "auto",

        grabCursor: true,

        navigation: {
            nextEl: ".images__next",
            prevEl: ".images__prev",
        },
        autoplay: {
            delay: 4000,
        },
    });
};

export const adsCarrousel = function (el) {
    const swiper = new Swiper(el, {
        speed: 500,
        centeredSlides: true,
        spaceBetween: 40,
        loop: true,
        slidesPerView: "auto",
        grabCursor: true,
        autoplay: {
            delay: 4000,
        },
    });
};
